import Alpine, { AlpineComponent } from 'alpinejs';
import { CatalogRules } from '../../types/form';
import { iodine } from '../../helpers/validation';
import { FormFieldValidationAlpine, getFieldValidation } from '../../helpers/fieldValidation';

interface ContactFormAlpine extends AlpineComponent<Record<string, any>> {
    [key: string]: any;
    form: HTMLFormElement;
    validate: () => void;
    formatFieldOrderNumber: (orderInput: HTMLTextAreaElement, event: InputEvent) => void;
}

const rules: CatalogRules = {
    civility: ['truthy'],
    firstname: ['required'],
    lastname: ['required'],
    zip: ['required'],
    city: ['required'],
    phone: ['required', 'trybaPhone'],
    email: ['required', 'email', 'noPlusInEmail'],
};

document.addEventListener('alpine:init', () => {
    // @ts-ignore
    Alpine.data('initFormValidation', (form: HTMLFormElement): ContactFormAlpine & FormFieldValidationAlpine => {
        return {
            ...getFieldValidation(rules),
            ...{
                form,
                validate(): void {
                    this.errorMessages = [];
                    const firstname = this.$refs.firstname as HTMLInputElement;
                    const lastname = this.$refs.lastname as HTMLInputElement;
                    // as zip is in x-data=simpleAutocomplete, it is not accessible in refs any more
                    const zip = document.querySelector('[name$="[zip]"]') as HTMLInputElement;
                    const city = this.$refs.city as HTMLInputElement;
                    const phone = this.$refs.phone as HTMLInputElement;
                    const email = this.$refs.email as HTMLInputElement;
                    const civilityMadam = this.$refs.civility_madam as HTMLInputElement;
                    const civilitySir = this.$refs.civility_sir as HTMLInputElement;

                    const contactItems = {
                        firstname: firstname.value,
                        lastname: lastname.value,
                        zip: zip.value,
                        city: city.value,
                        phone: phone.value,
                        email: email.value,
                        civility: civilityMadam.checked || civilitySir.checked,
                    };

                    const contactRules = {
                        firstname: rules.firstname,
                        lastname: rules.lastname,
                        zip: rules.zip,
                        city: rules.city,
                        phone: rules.phone,
                        email: rules.email,
                        civility: rules.civility,
                    };

                    const validation = iodine.assert({ ...contactItems }, { ...contactRules });

                    const submitButton = form.querySelector('button[type=submit]') as HTMLButtonElement;
                    if (validation.valid) {
                        submitButton.disabled = true;
                        form.submit();
                    } else {
                        submitButton.disabled = false;
                        this.displayErrors(validation);
                    }
                },
                formatFieldOrderNumber(orderInput: HTMLTextAreaElement, event: InputEvent): void {
                    if (event.data && new RegExp(/^[a-zA-Z]+$/, 'g').test(event.data)) {
                        orderInput.value = '92';
                    }
                },
            },
        };
    });
});
